module.exports = __webpack_public_path__ + "static/media/purchase_confirmation.11e2972f.svg";